/**
 * サンプル画像アセット (SVG Data URI)
 * (US-06: プリン、ピーチ)
 */

export const SAMPLE_PUDDING_SVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
  <defs>
    <radialGradient id="plateG" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="%23ffffff"/>
      <stop offset="85%" stop-color="%23e8e2d5"/>
      <stop offset="100%" stop-color="%23d0c6b6"/>
    </radialGradient>
    <linearGradient id="caramelG" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="%236e3519"/>
      <stop offset="100%" stop-color="%234a210d"/>
    </linearGradient>
    <linearGradient id="bodyG" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="%23ffeaa7"/>
      <stop offset="100%" stop-color="%23fdcb6e"/>
    </linearGradient>
    <filter id="shadow" x="-10%" y="-10%" width="120%" height="130%">
      <feDropShadow dx="0" dy="12" stdDeviation="15" flood-color="%23a08c7c" flood-opacity="0.35"/>
    </filter>
  </defs>
  <rect width="600" height="600" fill="%23fffaf2"/>
  
  <!-- お皿 -->
  <ellipse cx="300" cy="460" rx="240" ry="60" fill="url(%23plateG)" filter="url(%23shadow)"/>
  <ellipse cx="300" cy="455" rx="200" ry="45" fill="%23fdfcf9" stroke="%23dfd5c5" stroke-width="2"/>

  <!-- プリンの体 -->
  <path d="M 200,250 C 180,360 160,430 160,440 C 160,455 440,455 440,440 C 440,430 420,360 400,250 Z" fill="url(%23bodyG)"/>
  
  <!-- カラメルソース -->
  <path d="M 200,250 C 230,270 240,290 270,290 C 300,290 310,265 340,275 C 370,285 385,260 400,250 C 370,225 230,225 200,250 Z" fill="url(%23caramelG)"/>
  <ellipse cx="300" cy="245" rx="100" ry="25" fill="%23803c1b"/>

  <!-- かわいい顔 -->
  <circle cx="270" cy="360" r="10" fill="%234a210d"/>
  <circle cx="330" cy="360" r="10" fill="%234a210d"/>
  <ellipse cx="250" cy="375" rx="12" ry="7" fill="%23ff7675" opacity="0.6"/>
  <ellipse cx="350" cy="375" rx="12" ry="7" fill="%23ff7675" opacity="0.6"/>
  <path d="M 292,375 Q 300,385 308,375" fill="none" stroke="%234a210d" stroke-width="4" stroke-linecap="round"/>

  <!-- さくらんぼ -->
  <path d="M 300,230 C 320,180 340,165 370,160" fill="none" stroke="%2327ae60" stroke-width="5" stroke-linecap="round"/>
  <circle cx="300" cy="230" r="24" fill="%23d63031"/>
  <circle cx="293" cy="222" r="6" fill="%23ffffff" opacity="0.8"/>
  
  <!-- ハイライト -->
  <ellipse cx="215" cy="340" rx="12" ry="40" fill="%23ffffff" opacity="0.45" transform="rotate(-15 215 340)"/>
</svg>`;

export const SAMPLE_PEACH_SVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
  <defs>
    <radialGradient id="peachG" cx="45%" cy="40%" r="60%">
      <stop offset="0%" stop-color="%23ff9ebb"/>
      <stop offset="60%" stop-color="%23ff6b81"/>
      <stop offset="100%" stop-color="%23ee5253"/>
    </radialGradient>
  </defs>
  <rect width="600" height="600" fill="%23fff5f6"/>
  <ellipse cx="300" cy="510" rx="200" ry="30" fill="%23eddcd9"/>
  <!-- 桃の形状 -->
  <path d="M 300,200 C 220,130 130,220 150,340 C 170,460 270,490 300,500 C 330,490 430,460 450,340 C 470,220 380,130 300,200 Z" fill="url(%23peachG)"/>
  <!-- 葉っぱ -->
  <path d="M 300,190 C 270,120 220,130 200,150 C 230,180 270,180 300,190 Z" fill="%232ed573"/>
  <!-- 顔 -->
  <circle cx="250" cy="350" r="10" fill="%232f3542"/>
  <circle cx="350" cy="350" r="10" fill="%232f3542"/>
  <ellipse cx="230" cy="370" rx="14" ry="8" fill="%23ff4757" opacity="0.5"/>
  <ellipse cx="370" cy="370" rx="14" ry="8" fill="%23ff4757" opacity="0.5"/>
  <path d="M 292,365 Q 300,378 308,365" fill="none" stroke="%232f3542" stroke-width="4" stroke-linecap="round"/>
  <ellipse cx="200" cy="280" rx="20" ry="45" fill="%23ffffff" opacity="0.35" transform="rotate(-25 200 280)"/>
</svg>`;

export const SAMPLE_IMAGES = [
  { id: 'pouty_girl', name: '女の子', icon: '👧', src: '/samples/pouty_girl.jpg' },
  { id: 'pudding', name: 'プリン', icon: '🍮', src: SAMPLE_PUDDING_SVG },
  { id: 'peach', name: 'ピーチ', icon: '🍑', src: SAMPLE_PEACH_SVG },
  { id: 'nikukyu', name: '肉球', icon: '🐾', src: '/samples/cat_nikukyu.jpg' },
];
